<div
  class="toolbar w-full px-gutter"
  fxLayout="row"
  fxLayoutAlign="start center"
  vexContainer
>
  <button
    (click)="openSidenav()"
    [fxHide]="!mobileQuery"
    mat-icon-button
    type="button"
  >
    <mat-icon [icIcon]="icMenu"></mat-icon>
  </button>

  <a
    *ngIf="isVerticalLayout$ | async"
    [routerLink]="['/']"
    class="ltr:mr-4 rtl:ml-4 block"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <img class="w-8 select-none" src="./assets/images/aument-logo.png" />
    <h1
      [fxHide]="mobileQuery"
      class="title ltr:pl-4 rtl:pr-4 m-0 select-none mr-2"
    >
      Aument
    </h1>
  </a>

  <div
    *ngIf="(isVerticalLayout$ | async) && isNavbarInToolbar$ | async"
    [fxHide]="mobileQuery"
    class="px-gutter"
    fxFlex="none"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <vex-navigation-item
      *ngFor="let item of navigationItems"
      [item]="item"
    ></vex-navigation-item>
  </div>

  <span fxFlex></span>

  <div class="-mx-1 flex items-center">
    <div>
      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">
        <mat-icon *ngIf="currentLangIcon" [icIcon]="currentLangIcon"></mat-icon>
      </button>
    </div>

    <div>
      <vex-toolbar-user></vex-toolbar-user>
    </div>

    <mat-menu
      #languageMenu="matMenu"
      overlapTrigger="false"
      xPosition="before"
      yPosition="below"
    >
      <button mat-menu-item (click)="switchLanguage('en')">
        <mat-icon [icIcon]="emojioneEN"></mat-icon>
        <span>{{ 'language.en' | translate }}</span>
      </button>

      <button mat-menu-item (click)="switchLanguage('it')">
        <mat-icon [icIcon]="emojioneIT"></mat-icon>
        <span>{{ 'language.it' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>

<vex-navigation
  *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
  [fxHide]="mobileQuery"
></vex-navigation>
